// Written and cleared by the server next to the HttpOnly session cookies. Its
// presence means a session may exist. It carries no session detail and is never
// trusted for authorization.
export const SESSION_HINT_COOKIE = 'fa-session-hint';

// The expiry the server last stated for the access cookie. Kept here, away from
// the session service that owns it, so the Playwright specs can seed it.
export const ACCESS_EXPIRY_KEY = 'fa-access-expiry';
